const initialDog = {
	img: "",
	breed: {
		id: 0,
		name: "",
		temperament: "",
	},
};

export default initialDog;
